import { useEffect } from 'react';

const SEOSchema = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "HairSalon",
      "name": "ABR Barbearia",
      "image": "https://customer-assets.emergentagent.com/job_barbeiros-jundiai/artifacts/7x4qibhz_d5447bda-caff-46c8-b280-6f4eb83f8186.jpg",
      "description": "Barbearia premium em Jundiaí com atendimento de alto padrão. Corte masculino, barba, design e muito mais.",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Av. Humberto Cereser, 523",
        "addressLocality": "Jundiaí",
        "addressRegion": "SP",
        "addressCountry": "BR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": -23.1509794,
        "longitude": -46.8687034
      },
      "url": "https://abrbarbearia.com.br",
      "telephone": "+5511939079671",
      "priceRange": "$$",
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday"
        ],
        "opens": "09:00",
        "closes": "20:00"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "5",
        "reviewCount": "6"
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
};

export default SEOSchema;
